import Vue from "vue";
import actions from "./actions";

export default {
	namespaced: true,
	state: {
		logged: false,
		isDoctor: false,
		user: {},
		worker: {},
		clinic: {}
	},
	actions,
	mutations: {
		setUser(state, user) {
			state.user = user || {}
			state.logged = !!user._id
			Vue.storage.set('user', user._id)
			Vue.storage.set('X-Access-Token', user.token)
		},
		setAvatar(state, file) {
			state.user.attachment = file || {}
		},
		setWorker(state, worker = {}) {
			state.worker = worker
			state.isDoctor = !!worker._id
			Vue.storage.set('worker', worker._id)
		},
		setClinic(state, clinic) {
			state.clinic = clinic || {}
			Vue.storage.set('clinic', clinic._id)
		},
		clean(state) {
			state.logged = false
			state.isDoctor = false
			state.user = {}
			state.worker = {}
			state.clinic = {}
		}
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/auth/index.js